import {createSlides, initSlides, sliderDisplay} from "./common";
import {advertisersRefs, config} from "./config";
import Rails from "@rails/ujs";

Rails.start();

document.addEventListener("DOMContentLoaded", function(evt) {
  initSlides(function (){
    createSlides(advertisersRefs,"partners")
    sliderDisplay("partners");
  })
  loadPageContent();
});

function loadPageContent() {
  var req = new XMLHttpRequest();
  req.onload = function() {
    eval(req.responseText);
  };

  req.open("GET", config.backEndUrl + "/contacts/new.js");
  req.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  req.send();
}
